"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../../models");
var Accessor_1 = require("../../../models/Accessor");
var core_1 = require("../core");
var definedStartDateWindow_1 = require("../types/definedStartDateWindow");
var latestDataDateWindow_1 = require("../types/latestDataDateWindow");
var customDateWindow_1 = require("../types/customDateWindow");
var lastNDateWindow_1 = require("../types/lastNDateWindow");
var allTimeDateWindow_1 = require("../types/allTimeDateWindow");
var metricValue_1 = require("../../metricValue");
var EffectiveDefinition_1 = require("../../../models/EffectiveDefinition");
var defaultDateWindow_1 = require("./defaultDateWindow");
var dateUtils_1 = require("../../../dateUtils");
var dateWindowOptions_1 = require("./dateWindowOptions");
exports.dateWindowOptions = dateWindowOptions_1.dateWindowOptions;
var defaultDateWindow_2 = require("./defaultDateWindow");
exports.defaultDateWindow = defaultDateWindow_2.defaultDateWindow;
var displayDateWindow_1 = require("./displayDateWindow");
exports.displayDateWindow = displayDateWindow_1.displayDateWindow;
exports.displayStringFromWindow = displayDateWindow_1.displayStringFromWindow;
exports.granularityFromWindow = displayDateWindow_1.granularityFromWindow;
exports.getFirstWindowOrDefault = function (definition) {
    var _a;
    return _a = exports.getFirstWindow(definition), (_a !== null && _a !== void 0 ? _a : defaultDateWindowFor(definition));
};
exports.getFirstWindow = function (definition) {
    var _a, _b;
    return (_b = (_a = definition.features.dateWindow) === null || _a === void 0 ? void 0 : _a.dateWindows) === null || _b === void 0 ? void 0 : _b[0];
};
exports.getDefinitionWithServerOrDefaultWindow = function (definition, defaultWindow, dateWindowEnabled) {
    var _a;
    var window = (_a = (definition && exports.getFirstWindow(definition)), (_a !== null && _a !== void 0 ? _a : defaultWindow));
    return definition && exports.definitionWithWindow(definition, dateWindowEnabled ? window : defaultWindow);
};
var defaultDateWindowFor = function (definition) {
    var timestampFeature = metricValue_1.getTimestampFeature(definition.features);
    var timeColumnSchema = EffectiveDefinition_1.columnSchemaForRef(definition, timestampFeature);
    if (EffectiveDefinition_1.isDateTimeColumnSchema(timeColumnSchema)) {
        return defaultDateWindow_1.defaultDateWindow(models_1.dateTruncFromGranularity(timeColumnSchema.dateGranularity));
    }
    else {
        return allTimeDateWindow_1.ALL_TIME_DATE_WINDOW;
    }
};
exports.applyWindow = function (metricTable, dateWindow, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    return core_1.applyWindowFunction(metricTable, exports.windowFuncFromWindow(dateWindow, accessor));
};
exports.windowFuncFromWindow = function (dateWindow, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    switch (dateWindow.type) {
        case core_1.DateWindowTypes.CUSTOM:
            var customWindow = dateWindow;
            return customDateWindow_1.customDateWindow(customWindow.range, accessor);
        case core_1.DateWindowTypes.LAST_N:
            var lastNWindow = dateWindow;
            return lastNDateWindow_1.lastNDateWindow(lastNWindow.n);
        case core_1.DateWindowTypes.LATEST_DATA:
            var latestWindow = dateWindow;
            return latestDataDateWindow_1.latestDataDateWindow(latestWindow.duration, accessor);
        case core_1.DateWindowTypes.DEFINED_START:
            var definedStartDateDateWindow = dateWindow;
            return definedStartDateWindow_1.definedStartDateWindow(definedStartDateDateWindow.startDate, accessor);
        case core_1.DateWindowTypes.SPECIAL:
        default:
            return allTimeDateWindow_1.allTimeDateWindow();
    }
};
exports.definitionWithWindow = function (definition, dateWindow) {
    var newFeatures = __assign(__assign({}, definition.features), { dateWindow: { dateWindows: [dateWindow] } });
    return __assign(__assign({}, definition), { features: newFeatures });
};
exports.areWindowsEqual = function (window, other) {
    if (window.type !== other.type) {
        return false;
    }
    if (isCustomWindow(window) && isCustomWindow(other)) {
        return dateUtils_1.areRangesEqual(window.range, other.range);
    }
    else if (isLatestDataWindow(window) && isLatestDataWindow(other)) {
        return dateUtils_1.areDurationsEqual(window.duration, other.duration);
    }
    else if (isLastNWindow(window) && isLastNWindow(other)) {
        return window.n === other.n;
    }
    else if (isSpecialWindow(window) && isSpecialWindow(other)) {
        return window.specialType === other.specialType;
    }
    else if (isDefinedStartWindow(window) && isDefinedStartWindow(other)) {
        return window.startDate.getTime() === other.startDate.getTime();
    }
    return false;
};
function isLastNWindow(window) {
    return window.type === core_1.DateWindowTypes.LAST_N;
}
exports.isLastNWindow = isLastNWindow;
function isSpecialWindow(window) {
    return window.type === core_1.DateWindowTypes.SPECIAL;
}
exports.isSpecialWindow = isSpecialWindow;
function isLatestDataWindow(window) {
    return window.type === core_1.DateWindowTypes.LATEST_DATA;
}
exports.isLatestDataWindow = isLatestDataWindow;
function isCustomWindow(window) {
    return window.type === core_1.DateWindowTypes.CUSTOM;
}
exports.isCustomWindow = isCustomWindow;
function isDefinedStartWindow(window) {
    return window.type === core_1.DateWindowTypes.DEFINED_START;
}
exports.isDefinedStartWindow = isDefinedStartWindow;
//# sourceMappingURL=index.js.map